module.exports = __webpack_public_path__ + "static/LayerMobile-b2e3a6e717f73e2f9735cca49071ed70.png";